export const RIGHT_HAND_MESH_INFO = {
    type: "right_hand_default",
    file: "meshes/hands/Hand_A_17_right",
    meshesToBeUsedOnButtonPress: [
        {
            index: 0,
            subMeshNames: {
                pressed: "Hand_at_controller_closed",
                released: "Hand_at_controller_open"
            }
        }
    ]
};
export const LEFT_HAND_MESH_INFO = {
    type: "left_hand_default",
    file: "meshes/hands/Hand_A_17_left",
    meshesToBeUsedOnButtonPress: [
        {
            index: 0,
            subMeshNames: {
                pressed: "Hand_at_controller_closed",
                released: "Hand_at_controller_open"
            }
        }
    ]
};
